var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var Editor = require("../editor.jsx");
var TextInput = require("../components/text-input.jsx");

var DefinitionEditor = React.createClass({
    displayName: "DefinitionEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        togglePrompt: React.PropTypes.string,
        definition: React.PropTypes.string,
        apiOptions: React.PropTypes.any
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            togglePrompt: "",
            definition: ""
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    },


    render: function render() {
        var _this = this;

        return React.createElement(
            "div",
            { className: "perseus-widget-definition-editor" },
            React.createElement(
                "a",
                {
                    href: "https://docs.google.com/document/d/1udaPef4imOfTMhmLDlWq4SM0mxL0r3YHFZE-5J1uGfo",
                    target: "_blank"
                },
                "Definition style guide"
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Word to be defined:",
                    " ",
                    React.createElement(TextInput, {
                        value: this.props.togglePrompt,
                        onChange: this.change("togglePrompt"),
                        placeholder: "define me"
                    })
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(Editor, {
                    apiOptions: this.props.apiOptions,
                    content: this.props.definition,
                    widgetEnabled: false,
                    placeholder: "definition goes here",
                    onChange: function onChange(props) {
                        var newProps = {};
                        if (_.has(props, "content")) {
                            newProps.definition = props.content;
                        }
                        _this.change(newProps);
                    }
                })
            )
        );
    }
});

module.exports = DefinitionEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/definition-editor.jsx
 ** module id = 103
 ** module chunks = 0 1
 **/